module.exports = __webpack_public_path__ + "img/logo-towers-highlight.00447269.png";